import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { groundsClose } from '@src/public/utils/app';
import styles from './index.css';

const Header = ({ statusBarHeight }) => {
    return (
        <div className={styles.wrap} style={{ paddingTop: statusBarHeight }}>
            <div className={styles.content}>
                <div
                    className={styles.arrowClose}
                    onClick={() => {
                        groundsClose();
                    }}
                />
            </div>
        </div>
    );
};

Header.propTypes = {
    statusBarHeight: PropTypes.number,
};

export default errorBoundary(Header);
